export const getPriorityBadge = (priority) => {
  const colors = {
    urgent: '#dc3545',
    high: '#fd7e14',
    normal: '#0d6efd',
    low: '#6c757d'
  };
  return (
    <span 
      className="priority-badge" 
      style={{ backgroundColor: colors[priority] || colors.normal }}
    >
      {priority.toUpperCase()}
    </span>
  );
};
